import { useQuery } from "@apollo/client";
import { useLocation } from "react-router-dom";
import useCookie from "hooks/useCookie";
import { validateHopMiraklSsoQuery } from "./queries";
import { ValidateHopMiraklSso } from "TypesAndInterfaces";
import "./HOPAuth.scss";


const HOPAuth = () => {
  const [getHopStateCookie] = useCookie("hopState");
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const state = params.get("state");
  const code = params.get("code");

  const {
    data: validateHopMiraklSsoData,
    loading: validateHopMiraklSsoLoading,
    error: validateHopMiraklSsoError,
  } = useQuery<{ validateHopMiraklSso: ValidateHopMiraklSso }>(
    validateHopMiraklSsoQuery,
    {
      variables: { state, code },
      skip: !state && !code,
      onCompleted: (data) => {
        if (data?.validateHopMiraklSso?.redirectUrl) {
          window.open(
            data?.validateHopMiraklSso?.redirectUrl,
            "_self"
          );
        }
      },
    }
  );

  if (validateHopMiraklSsoLoading && !validateHopMiraklSsoData) {
    return <p>Loading</p>;
  }

  if (validateHopMiraklSsoError) {
    return <p>Bad Request: {validateHopMiraklSsoError.message}</p>;
  }

  return (
    <div className="page">
      {validateHopMiraklSsoData?.validateHopMiraklSso && state === getHopStateCookie() ? (
        <main className="main-container-wrapper hop-auth-wrapper">
          <h2>Redirecting...</h2>
          <p>
            Do you have any trouble with the redirection?<br />
            Click <a href={validateHopMiraklSsoData?.validateHopMiraklSso.redirectUrl}>here</a> to be redirected!
          </p>
        </main>
      ) : (
        <p>Bad Request</p>
      )}
    </div>
  );
};

export default HOPAuth;
